// extracted by mini-css-extract-plugin
export var cell = "_6w-4";
export var headerCell = "_6w-2";
export var rowHeader = "_6w-3";
export var table = "_6w-1";
export var tableContainer = "_6w-0";